module.exports = __webpack_public_path__ + "img/c-b1.6e237442.png";